<template>
    <b-modal 
        v-model="modalForm.isOpen" 
        title="Configuración de países" 
        hide-footer 
        size="lg"
        centered
        no-close-on-backdrop
        no-close-on-esc
        @hide="onHandleCancelStoreConfigurableVariable"
    >
        <!-- Formulario -->
        <form @submit.prevent="onHandleStoreConfigurableVariable" data-vv-scope="countryConfigForm">

            <!-- Selector de País y Switch Principal -->
            <b-row class="mb-3">
                <b-col cols="12" md="11" class="mb-3 mb-md-0">
                    <label for="configurableVariable_slq_country_id" class="form-label">
                        Seleccionar País <span class="text-danger">*</span>
                    </label>
                    <el-select 
                        v-model="configurableVariable.slq_country_id" 
                        filterable 
                        clearable
                        no-data-text="No hay datos disponibles" 
                        no-match-text="No se encontraron coincidencias"
                        id="configurableVariable_slq_country_id" 
                        name="configurableVariable_slq_country_id"
                        data-vv-as="País"
                        v-validate="'required'" 
                        @change="onHandleChangeCountry($event)"
                        placeholder="Buscar y seleccionar país..."
                        class="w-100"
                        :class="{ 'is-invalid': errors.has('countryConfigForm.configurableVariable_slq_country_id') }"
                    >
                        <el-option 
                            v-for="country in configuredCountries" 
                            :key="country.id"
                            :label="`${country.name} (${country.code})`" 
                            :value="country.id"
                        >
                            <div class="d-flex align-items-center">
                                <img 
                                    :src="`https://flagsapi.com/${country.code}/flat/24.png`" 
                                    :alt="`Bandera de ${country.name}`"
                                    class="mr-2"
                                    style="width: 24px; height: 18px; border-radius: 2px;"
                                    @error="onFlagError($event)"
                                />
                                <span>{{ country.name }} ({{ country.code }})</span>
                            </div>
                        </el-option>
                    </el-select>
                    <div 
                        class="invalid-feedback d-block"
                        v-if="errors.has('countryConfigForm.configurableVariable_slq_country_id')"
                    >
                        {{ errors.first('countryConfigForm.configurableVariable_slq_country_id') }}
                    </div>
                </b-col>

                <b-col cols="12" md="1" class="d-flex align-items-end justify-content-md-end">
                    <div class="switch-container">
                        <label class="switch-label">Principal</label>
                        <div class="custom-switch">
                            <input 
                                type="checkbox" 
                                id="is_main_switch"
                                v-model="configurableVariable.is_main"
                                class="switch-input"
                            >
                            <label for="is_main_switch" class="switch-slider"></label>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <!-- Información de Contacto -->
            <b-row class="mb-4">
                <!-- Indicativo -->
                <b-col cols="12" md="3" class="mb-3 mb-md-0">
                    <label for="configurableVariable_phone_code" class="form-label">
                        Indicativo
                    </label>
                    <div class="input-group">
                        <span class="input-group-text">+</span>
                        <b-form-input 
                            type="text" 
                            id="configurableVariable_phone_code"
                            name="configurableVariable_phone_code" 
                            v-model="configurableVariable.phone_code"
                            data-vv-as="Indicativo" 
                            v-validate="'max:5|numeric'"
                            placeholder="57" 
                            maxlength="5"
                            :class="{ 'is-invalid': errors.has('countryConfigForm.configurableVariable_phone_code') }"
                        />
                    </div>
                    <div 
                        class="invalid-feedback d-block"
                        v-if="errors.has('countryConfigForm.configurableVariable_phone_code')"
                    >
                        {{ errors.first('countryConfigForm.configurableVariable_phone_code') }}
                    </div>
                </b-col>

                <!-- Teléfono de Emergencia -->
                <b-col cols="12" md="9">
                    <label for="configurableVariable_phone" class="form-label">
                        Teléfono de Emergencia
                    </label>
                    <b-form-input 
                        type="tel" 
                        id="configurableVariable_phone" 
                        name="configurableVariable_phone"
                        v-model="configurableVariable.phone" 
                        data-vv-as="Teléfono de emergencia" 
                        v-validate="'max:30|min:7'"
                        placeholder="(123) 456-7890"
                        maxlength="30"
                        :class="{ 'is-invalid': errors.has('countryConfigForm.configurableVariable_phone') }"
                    />
                    <div 
                        class="invalid-feedback d-block"
                        v-if="errors.has('countryConfigForm.configurableVariable_phone')"
                    >
                        {{ errors.first('countryConfigForm.configurableVariable_phone') }}
                    </div>
                    <small class="form-text text-muted">Número para contacto en casos de emergencia</small>
                </b-col>
            </b-row>

            <!-- Botones -->
            <div class="d-flex justify-content-end gap-2">
                <b-button 
                    variant="danger" 
                    @click.prevent="onHandleCancelStoreConfigurableVariable"
                >
                    Cancelar
                </b-button>
                <b-button 
                    type="submit" 
                    variant="primary"
                    @click.prevent="onHandleStoreConfigurableVariable"
                    :disabled="isSubmitting"
                >
                    <span v-if="isSubmitting">Procesando...</span>
                    <span v-else>{{ getAction ? 'Guardar' : 'Actualizar' }}</span>
                </b-button>
            </div>

        </form>
    </b-modal>
</template>

<script>
// Importaciones generales
import { mapMutations, mapState, mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
    name: 'ModalFormConfigurableVariables',
    data() {
        return {
            isSubmitting: false,
            defaultFlagUrl: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0xMiA2TDYgMTBIMThMMTIgNloiIGZpbGw9IiM5OTk5OTkiLz4KPC9zdmc+'
        }
    },
    computed: {
        // Estados del modulo Empresas
        ...mapState('empresa', [
            'selectedEmpresa'
        ]),
        // Estados del modulo Configuración de países.
        ...mapState('configurableVariables', [
            'modalForm',
            'configurableVariable',
            'filter'
        ]),
        // Estados del modulo Listas
        ...mapState('sysList', {
            languages: 'lists'
        }),
        // Estados del modulo Países
        ...mapState('countries', ['countries', 'configuredCountries']),
        
        /**
         * Obtener la acción actual.
         * @author Fernando Claros
         */
        getAction() {
            return this.modalForm.action === 'CREATE';
        }
    },
    methods: {
        // Mutaciones del modulo Configuración de países.
        ...mapMutations('configurableVariables', [
            'setModalForm',
            'setDefaultConfigurableVariable',
            'setConfigurableVariable'
        ]),
        // Acciones del modulo Configuración de países.
        ...mapActions('configurableVariables', [
            'storeConfigurableVariable',
            'updateConfigurableVariable'
        ]),
        
        /**
         * Crear/Editar configuración de países.
         * @author Fernando Claros
         */
        async onHandleStoreConfigurableVariable() {
            this.isSubmitting = true;
            
            try {
                const isValid = await this.$validator.validateAll('countryConfigForm');
                
                if (!isValid) {
                    this.isSubmitting = false;
                    return;
                }

                const payload = {
                    ...this.configurableVariable,
                    slq_company_id: this.selectedEmpresa.id,
                    is_active: this.configurableVariable.is_active ? 1 : 0,
                    is_main: this.configurableVariable.is_main ? 1 : 0,
                    page: this.filter.page,
                    status: 'ALL'
                };

                if (this.modalForm.action === 'CREATE') {
                    await this.storeConfigurableVariable(payload);
                } else {
                    await this.updateConfigurableVariable(payload);
                }
                
            } catch (error) {
                console.error('Error al procesar configuración de país:', error);
            } finally {
                this.isSubmitting = false;
            }
        },
        
        /**
         * Cancelar acción de crear/editar configuración de países.
         * @author Fernando Claros
         */
        onHandleCancelStoreConfigurableVariable() {
            this.$validator.reset();
            this.setDefaultConfigurableVariable();
            this.setModalForm({
                isOpen: false,
                action: 'CREATE'
            });
            this.isSubmitting = false;
        },
        
        /**
         * Cambiar de país seleccionado.
         * @author Fernando Claros
         */
        onHandleChangeCountry(selectedCountryId) {
            const country = this.configuredCountries.find(x => x.id === selectedCountryId);

            if (country && country.phone_code) {
                if (this.configurableVariable.phone_code && this.configurableVariable.phone_code !== country.phone_code) {
                    Swal.fire({
                        icon: 'question',
                        title: 'Configuración de países',
                        text: `El país seleccionado (${country.name}) tiene el indicativo +${country.phone_code}. ¿Desea utilizarlo?`,
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonText: `Sí, usar +${country.phone_code}`,
                        denyButtonText: 'No, mantener actual'
                    }).then(result => {
                        if (result.isConfirmed) {
                            this.configToUseCustomizedPhoneCode(country.phone_code);
                        }
                    });
                } else {
                    this.configToUseCustomizedPhoneCode(country.phone_code);
                }
            }
        },
        
        /**
         * Usar el prefijo predefinido por el usuario.
         * @author Fernando Claros
         */
        configToUseCustomizedPhoneCode(phoneCode) {
            this.setConfigurableVariable({ 
                ...this.configurableVariable, 
                phone_code: phoneCode 
            });
        },

        /**
         * Manejar error al cargar banderas
         */
        onFlagError(event) {
            event.target.src = this.defaultFlagUrl;
        }
    },
    
    watch: {
        'modalForm.isOpen'(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            }
        }
    }
};
</script>

<style scoped>
/* Estilos modernos y limpios */
.form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: #495057;
}

.form-check-label {
    color: #495057;
    margin-left: 0.5rem;
}

.form-text {
    font-size: 0.875rem;
    margin-top: 0.25rem;
}

.gap-2 {
    gap: 0.5rem;
}

/* Switch personalizado */
.switch-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
}

.switch-label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #495057;
    margin: 0;
}

.custom-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
}

.switch-input {
    opacity: 0;
    width: 0;
    height: 0;
}

.switch-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.3s;
    border-radius: 24px;
}

.switch-slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.switch-input:checked + .switch-slider {
    background-color: #007bff;
}

.switch-input:checked + .switch-slider:before {
    transform: translateX(26px);
}

.switch-slider:hover {
    box-shadow: 0 0 8px rgba(0,123,255,0.3);
}

/* Estilos para Element UI */
:deep(.el-select) {
    width: 100%;
}

:deep(.el-select .el-input__inner) {
    border-radius: 0.375rem;
    border-color: #ced4da;
    height: 38px;
    line-height: 38px;
    font-size: 1rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

:deep(.el-select .el-input__inner:focus) {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

:deep(.el-select.is-invalid .el-input__inner) {
    border-color: #dc3545;
}

:deep(.el-select .el-input__inner::placeholder) {
    color: #6c757d;
}

/* Responsive improvements */
@media (max-width: 767.98px) {
    .form-check {
        margin-top: 1rem;
        justify-content: flex-start !important;
    }
    
    :deep(.modal-dialog) {
        margin: 1rem;
    }
}
</style>